import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { loadGuestPreferences, patchGuestPreferences } from "@/lib/guestPreferences";
import { normalizeUnitSystem } from "@/lib/units";

const UnitPreferenceContext = createContext(null);

export function UnitPreferenceProvider({ children }) {
  const { user } = useAuth();
  const [unitSystem, setUnitSystemState] = useState(() => loadGuestPreferences().unitSystem);

  useEffect(() => {
    setUnitSystemState(loadGuestPreferences().unitSystem);
  }, [user]);

  const setUnitSystem = useCallback((value) => {
    const normalized = normalizeUnitSystem(value);
    setUnitSystemState(normalized);
    patchGuestPreferences({ unitSystem: normalized });
  }, []);

  const value = useMemo(() => ({ unitSystem, setUnitSystem }), [setUnitSystem, unitSystem]);
  return <UnitPreferenceContext.Provider value={value}>{children}</UnitPreferenceContext.Provider>;
}

export const useUnitPreference = () => useContext(UnitPreferenceContext);
